var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FullElemInPC,{tag:"component",scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.$t('enterprise.communication-and-connection--RYC')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }